// extracted by mini-css-extract-plugin
export var card = "_lr-1";
export var summary = "_lr-0";